/** Prefix for auto-generated placeholder account codes (NAV code assigned later). */
export const TEMP_ACCOUNT_CODE_PREFIX = 'TEMP-';

export function isTempAccountCode(code: string | null | undefined): boolean {
  return (code ?? '').trim().toUpperCase().startsWith(TEMP_ACCOUNT_CODE_PREFIX);
}

export function generateTempAccountCode(): string {
  const suffix =
    typeof crypto !== 'undefined' && 'randomUUID' in crypto
      ? crypto.randomUUID().replace(/-/g, '').slice(0, 12).toUpperCase()
      : `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 6)}`.toUpperCase();
  return `${TEMP_ACCOUNT_CODE_PREFIX}${suffix}`;
}

export function resolveAccountCodeForSave(raw: string, isNew: boolean): string {
  const trimmed = raw.trim();
  if (isNew && !trimmed) {
    return generateTempAccountCode();
  }
  return trimmed;
}

export function isValidPermanentAccountCode(code: string): boolean {
  const trimmed = code.trim();
  return trimmed.length > 0 && !isTempAccountCode(trimmed);
}
